export function calculatePercentage(
    totalAmount: number,
    percentageAmount: number
): number {
    if (totalAmount === 0) {
        return 0; // To avoid division by zero
    }
    return Math.round((percentageAmount / totalAmount) * 100);
}
